import 'handsontable';
import validators from '../../../Gull/Framework/validators.js';

const Handsontable = window.Handsontable;

// Handsontable validator functions
var handsontableValidators = {

	// Create the validators on init
	init: function() {

		handsontableValidators.createValidators();

	},

	// Connector function for the default validation library
	connector: function(result) {
		if (result == 'success') {
			return true;
		} else {
			return false;
		}
	},

	// Function that creates all validators
	createValidators: function() {

		// Register validators voor elke validator functie TODO: Herschrijven naar forEach als ie 11 uitgefaseerd wordt
		$.each(validators, function(key) {

			// Register validator
			window.Handsontable.validators.registerValidator(key, function(value, callback) {
				if (!handsontableValidators.connector(validators.notEmpty(value))) {
					// Waarde mag niet leeg zijn dus return false als de waarde leeg is of niet geset
					callback(false);
				} else {
					// Valideer de waarde met de validatie functie
					var result = handsontableValidators.connector(validators[key](value));
					callback(result);
				}
			});

			// Register zelfde validator die ook leeg mag zijn
			window.Handsontable.validators.registerValidator(key + 'OrEmpty', function(value, callback) {

				if (!handsontableValidators.connector(validators.notEmpty(value))) {
					// Waarde mag leeg zijn dus return true als de waarde leeg is of niet geset
					callback(true);
				} else {
					// Valideer de waarde met de validatie functie
					var result = handsontableValidators.connector(validators[key](value));
					callback(result);
				}
			});

		});

	}

};

export default handsontableValidators;
